import raw from '../../shop.config.json';
import type { ShopConfig } from '@/types/models';

/**
 * shop.config.json is the SmartCity Contractors' productization contract.
 * Everything client-specific lives here. Change these values to reskin
 * the entire app for a different barbershop client.
 *
 * Full contract documented in:
 *   docs/BUILD_PLAN_PHASE_1.md section 10 (Productization contract)
 */
export const config = raw as ShopConfig;
export default config;
